import { useSearchParams } from "react-router-dom";
import { Table } from "../../../features/Table";
import { type E3PdfPageSelection, columns } from "./columns";
import {
  type FilterE3PdfPageSelectionSchema,
  E3PdfPageSelectionFilter,
} from "./filter";

export const E3PdfPageSelectionTable = () => {
  const [searchParams] = useSearchParams();
  const client = searchParams.get("client") || "e3";
  const table_name = "e3_pdf_page_selection";

  return (
    <Table<E3PdfPageSelection, FilterE3PdfPageSelectionSchema>
      label="Sélection de pages PDF"
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<E3PdfPageSelectionFilter />}
      disable_translations_request={true}
      columnVisibilityInit={{
        tableau_view: false,
        tableau_workbook_id: false,
        created_at: false,
      }}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
